module.exports = __webpack_public_path__ + "img/image7@2x.033331ab.png";